module.exports = __webpack_public_path__ + "img/packing_new_stock.78d388ce.svg";